import CameraNotSending from "./CameraNotSending";

const AdminCameraPage = () => {
  return <CameraNotSending />;
};

export default AdminCameraPage;
